/** Способ создания черновика: декларирование доходов от сдачи жилья в аренду */
export const DRAFT_MODE = 6;
export const STEP_INCOME = 'income';
export const STEP_INCOME_FORM = `${STEP_INCOME}Form`;

export const INDIVIDUAL_SOURCE_TYPE = 2; // source type for individual
export const RENTAL_INCOME_TYPE_CODE = 1400; // income type code for the rental income
export const TAX_RATE = 13; // taxRate the rental income
